import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class AuthFormartMixin extends Vue {
  /**
   *
   * @param phoneNumber
   */
  checkPhoneNumber(phoneNumber: string): boolean {
    return (
      !!phoneNumber &&
      phoneNumber.length === 11 &&
      /^[1-9][0-9]+$/.test(phoneNumber)
    );
  }
}
